import { Section, SelectorIdentifier } from '../../models';
import { FlexSectionIds } from './base-config-models';
import { DataDeliveryFieldId } from '../common.models';
import { field } from '../../core/field-schema';
import { required, custom } from '../../core/validator-builders';
import { ValidatorIdentifier } from '../../models/validator-identifier';
import { SampleRateElement } from '../../../models/location-card.model';
import { FlexLocationCardState } from './models';

/**
 * Triton Data Delivery Configuration Section
 */
export const dataDelivery = (state: FlexLocationCardState): Section => {
    const config = state.monitorConfiguration

    const isEditMode = !!config;

    return {
        info: {
            id: FlexSectionIds.DataDelivery,
            title: 'ADD_EDIT.ADD_EDIT_DATA_DELIVERY',
            displayTitle: true,
            expandable: true,
            expanded: false,
        },
        rows: [
            // Delivery Rates Row
            {
                info: {
                    id: 'delivery-rates-row',
                    panelClass: 'custom-50p',
                },
                items: [
                    field.select<SampleRateElement, number>(DataDeliveryFieldId.PrismDeliveryNormal, 'prismdeliverynormal', {
                        label: 'ADD_EDIT.INPUT_PLACEHOLDER_NORMAL_RATE',
                        placeholder: 'ADD_EDIT.INPUT_PLACEHOLDER_NORMAL_RATE',
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        panelClass: 'custom-width',
                        value: isEditMode ? config.telemetryNormalInterval : 900,
                        validators: [
                            required({
                                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.TRITON_REQUIRED_ERRORS_TXT',
                            }),
                            custom({
                                identifier: ValidatorIdentifier.DeliveryRateValidator,
                                message: 'COMMON.FLEX_DATA_DELIVERY_RATE_ERROR',
                            }),
                        ],
                        optionsSelector: SelectorIdentifier.FlexDataDeliveryNormalRateList,
                    }),
                    field.select<SampleRateElement, number>(DataDeliveryFieldId.PrismDeliveryFast, 'prismdeliveryfast', {
                        label: 'ADD_EDIT.INPUT_PLACEHOLDER_FAST_RATE',
                        placeholder: 'ADD_EDIT.INPUT_PLACEHOLDER_FAST_RATE',
                        panelClass: 'custom-width',
                        value: isEditMode ? config.telemetryFastInterval : 900,
                        valueMapper: (option) => option.value,
                        displayMapper: (option) => option.text,
                        validators: [
                            required({
                                message: 'HOME.MAP.MARKER_LOCATION_DETAIL.TRITON_REQUIRED_ERRORS_TXT',
                            }),
                            custom({
                                identifier: ValidatorIdentifier.DeliveryRateValidator,
                                message: 'COMMON.FLEX_DATA_DELIVERY_RATE_ERROR',
                            }),
                        ],
                        optionsSelector: SelectorIdentifier.FlexDataDeliveryFastRateList,
                    }),
                ],
            },
        ],
    };
};
